import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { appLanguageSelector } from '../../../redux/app/selectors'
import { formulasSelector } from '../selectors/selectors'
import { useFormulaOptions } from './useFormulaOptions'

export const useCompanyFormulas = (companyId?: string) => {
  const lng = useSelector(appLanguageSelector)
  const options = useFormulaOptions({ companyId, lng, select: formulasSelector })
  return useQuery(options)
}
